import React from 'react'
import PropTypes from 'prop-types'

import CheckboxFieldWrapper from './CheckboxFieldWrapper'
import CheckboxFieldLabel from './CheckboxFieldLabel'
import CheckboxFieldHelp from './CheckboxFieldHelp'
import Checkbox from '../Checkbox'

function CheckboxField({
  name,
  id = name,
  label,
  prependLabel,
  full,
  error,
  help,
  ...props
}) {
  const labelNode = (
    <CheckboxFieldLabel
      htmlFor={id}
      prepend={prependLabel}
      error={error}
    >
      {label}
    </CheckboxFieldLabel>
  )

  return (
    <CheckboxFieldWrapper full={full}>
      {prependLabel && labelNode}
      <Checkbox
        {...props}
        name={name}
        error={error}
        id={id}
      />
      {!prependLabel && labelNode}
      {help && <CheckboxFieldHelp error={error}>{help}</CheckboxFieldHelp>}
    </CheckboxFieldWrapper>
  )
}

CheckboxField.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  label: PropTypes.node.isRequired,
  prependLabel: PropTypes.bool,
  full: PropTypes.bool,
  error: PropTypes.bool,
  help: PropTypes.node
}

CheckboxField.defaultProps = {
  full: true
}

export default CheckboxField
